import React, { useContext } from 'react';
import { ProductActionsSummary } from 'src/components/ProductDetail/ProductActions';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';
import { BundleOptionsContext } from 'src/components/BundleProduct/BundleOptionsProvider';
import { bundleCustomisationProps } from 'src/components/BundleProduct/utils/formToCustomisation';
import { validateArtwork } from 'src/util/validateArtwork';
import { errorMessage, warningMessage } from 'src/util/state-helpers';

import { Messages } from '../Messages/Messages';
import { BundleErrors } from '../BundleErrors/BundleErrors';

import { BundleSelectionContext, useFormDataCausesRender } from './BundleSelectionProvider';

export const BundleProductActions: React.FC<{
    artworksData: bundleCustomisationProps;
    artworksFee: number;
    artworksPrice: number;
    setSumBundlePrice: React.Dispatch<React.SetStateAction<{ price: number; price_incl: number }>>;
}> = (props) => {
    const { artworksData, artworksPrice, artworksFee, setSumBundlePrice } = props;

    const { vat } = useVatCausesRender();
    const { maxQty } = useContext(BundleSelectionContext);
    const { bundlePrice } = useContext(BundleOptionsContext);
    const { totalQty } = useFormDataCausesRender();
    const { isValid, errors } = artworksData && validateArtwork(artworksData);

    const isDisabled = !isValid || totalQty === 0 || totalQty > maxQty || (totalQty > 0 && totalQty < maxQty);

    let price = vat ? bundlePrice.price_incl : bundlePrice.price;
    // If we have more than 1 logo, sum prices
    if ((artworksPrice && artworksFee) || artworksFee === 0) {
        price += artworksPrice * maxQty + artworksFee;
    }

    React.useEffect(() => {
        // Use it for updating price at the top of the bundle page
        setSumBundlePrice({
            price: price,
            price_incl: price,
        });
    }, [price, setSumBundlePrice]);

    return (
        <>
            <ProductActionsSummary
                itemPrice={null}
                totalPrice={price}
                isPending={false}
                vat={vat}
                disabled={isDisabled}
            />
            <div>
                <BundleErrors errors={errors} />
                {totalQty === 0 && <Messages messages={[warningMessage(`Please add proper number of items`)]} />}
                {totalQty > maxQty && (
                    <Messages
                        messages={[errorMessage(`You've added too many items - this deal is limited to ${maxQty}`)]}
                    />
                )}
                {totalQty > 0 && totalQty < maxQty && (
                    <Messages
                        messages={[warningMessage(`You havn't added enough items yet - this deal requires ${maxQty}`)]}
                    />
                )}
            </div>
        </>
    );
};
